import { render, staticRenderFns } from "./EGBAnalysisTab.vue?vue&type=template&id=8ec10a0c&"
import script from "./EGBAnalysisTab.vue?vue&type=script&lang=js&"
export * from "./EGBAnalysisTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports